export default __webpack_public_path__ + "static/media/baptism.a0ba06da.svg";